import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withTranslation } from 'react-i18next'
import Modal from '../../Components/Modal';
import TextInput from '../../Components/TextInput';
import DropDown from '../../Components/DropDown';
import commonActions from '../../Actions/commonActions';
import customerActions from '../../Actions/customerActions';
import StaticTextInput from '../../Components/StaticTextInput';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import useProductName from "../../Hooks/useProductName";
import {productId} from "../../Constants/producs";
import customerRoutes from "../../Constants/Customer/customerRoutes";

function AOCustomerInformationModal ({customer, customerActions, commonActions, onClose, form, dropdownlists, t }) {

    const [supplierHover, setSupplierHover] = useState(false)
    const [assignmentHover, setAssignmentHover] = useState(false)
    const [eEkonomiHover, seteEkonomiHover] = useState(false)

    const {translatedProductName} = useProductName();
    const productName = translatedProductName(productId.tegner);

    const navigate = useNavigate()

    useEffect(() => {
        commonActions.loadDropdownList("AoSuppliers");
        customerActions.startAOCustomerInfoEdit(customer.vbCustomer.customerNumber);
    }, [])

    const handleClickClose = () => {
        commonActions.cancelFormEditing("editAOCustomerInfo", onClose);
    }

    const handleClickSave = () => {
        customerActions.saveAoCustomerInfo(form, () => handleClickClose());
    }

    const handleFieldChange = (field, value) => {
        commonActions.changeMultiFormField(form.id, field, value);
    }

    const handleAdditionalButtonClick = () => {
        customerActions.saveAoCustomerInfo(form, () => handleRedirect());
        handleRedirect();
    }

    const handleRedirect = () => {
        handleClickClose();
        navigate(customerRoutes.newAppointment);
    }


    const customerInfo = form && form.data;

    if (!customerInfo)
        return null;

    const suppliers = dropdownlists?.AoSuppliers;

    const modalProps = {
        title: t('aocustomerinformation.modalheader'),
        mainButtonTitle: t('aocustomerinformation.save'),
        onCancelClick: handleClickClose,
        stateful: true,
        open: true,
        onSaveClick: handleClickSave,
        additionalButton: true,
        additionalButtonTitle: t('aocustomerinformation.saveandtoappointment'),
        onAdditionalClick: handleAdditionalButtonClick
    }

    let eEkonomiDate;
    if (customerInfo.eekonomiChangeDate)
        eEkonomiDate = moment(customerInfo.eekonomiChangeDate).format("DD-MM-YYYY");

    const iconStyle = 'vismaicon vismaicon-sm vismaicon-filled vismaicon-help cursorpointer';

    const accountingSuppliers = suppliers?.find(s => s.name === 'accounting');
    const payrollSuppliers = suppliers?.find(s => s.name === 'payroll');
    const clientHandlerSuppliers = suppliers?.find(s => s.name === 'clientHandler');
    const financialStatementsSuppliers = suppliers?.find(s => s.name === 'financialStatements');

    return (
        <Modal {...modalProps}>
            <form className='form-horizontal col-xs-10'>
                <TextInput
                    label={<>{t('aocustomerinformation.assignments')} <i onMouseEnter={() => setAssignmentHover(true)}
                                                                         onMouseLeave={() => setAssignmentHover(false)}
                                                                         className={iconStyle}></i> </>}
                    onChange={handleFieldChange.bind(this, 'accountingAssignments')}
                    value={customerInfo.accountingAssignments}>
                </TextInput>
                {assignmentHover && <div
                    className='table-content-hover'>{t('aocustomerinformation.assignmentedithover', {productName})}</div>}
                <TextInput
                    label={<>{t('aocustomerinformation.eekonomi', {productName})} <i
                        onMouseEnter={() => seteEkonomiHover(true)} onMouseLeave={() => seteEkonomiHover(false)}
                        className={iconStyle}></i>  </>}
                    onChange={handleFieldChange.bind(this, 'eekonomi')} value={customerInfo.eekonomi}>
                </TextInput>
                {eEkonomiHover && <div
                    className='table-content-hover'>{t('aocustomerinformation.eekonomiedithover', {productName})}</div>}
                {customerInfo.eekonomiChangeDate &&
                    <StaticTextInput label={t('aocustomerinformation.eekonomichangedate', {productName})}
                                     value={eEkonomiDate}/>}
                <br/>
                <legend>{t('aocustomerinformation.supplier')} <i onMouseEnter={() => setSupplierHover(true)}
                                                                 onMouseLeave={() => setSupplierHover(false)}
                                                                 className={iconStyle}></i></legend>
                {supplierHover &&
                    <div className='table-content-hover'>{t('aocustomerinformation.supplieredithover')}</div>}
                <DropDown label={t('aocustomerinformation.accounting')} blankOption={true} nameValued={true}
                          onChange={handleFieldChange.bind(this, 'accounting')} list={accountingSuppliers?.subOptions}
                          value={customerInfo.accounting}/>
                <DropDown label={t('aocustomerinformation.payroll')} blankOption={true} nameValued={true}
                          onChange={handleFieldChange.bind(this, 'payroll')} list={payrollSuppliers?.subOptions}
                          value={customerInfo.payroll}/>
                <DropDown label={t('aocustomerinformation.clienthandler')} blankOption={true} nameValued={true}
                          onChange={handleFieldChange.bind(this, 'clientHandler')}
                          list={clientHandlerSuppliers?.subOptions} value={customerInfo.clientHandler}/>
                <DropDown label={t('aocustomerinformation.financialstatements')} blankOption={true} nameValued={true}
                          onChange={handleFieldChange.bind(this, 'financialStatements')}
                          list={financialStatementsSuppliers?.subOptions} value={customerInfo.financialStatements}/>
                <div className="clearfix"></div>
            </form>
        </Modal>
    );
}

function mapStateToProps(state) {
    return {
        customer: state.CustomerReducer.customer,
        form: state.CommonReducer.forms && state.CommonReducer.forms.updateAOCustomerInfoModal,
        dropdownlists: state.CommonReducer.dropdownlists,
        user: state.CommonReducer.user
    }
}


function mapDispatchToProps(dispatch) {
    return {
        commonActions: bindActionCreators(commonActions, dispatch),
        customerActions: bindActionCreators(customerActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AOCustomerInformationModal));
